module.exports = __webpack_public_path__ + "media/images/start_header-585b4490e605b9720d4abffd9ef048bd.webp";